import type { VoidFunctionComponent } from 'react';

import { Badge, BadgeColors } from '../../generic';

type Props = {
  confidence: number;
};

/**
 * Displays a badge indicating the confidence level of a snippet.
 */
const ConfidenceBadge: VoidFunctionComponent<Props> = ({ confidence }) => {
  const isHigh = confidence > 0.5;
  const color = isHigh ? BadgeColors.LightGreen : BadgeColors.LightYellow;
  const text = isHigh ? 'High' : 'Low';
  return (
    <Badge color={color}>
      {text}
    </Badge>
  );
};

export default ConfidenceBadge;
